import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';

export function exportToXlsx(data, mainCols, filename = 'export.xlsx') {
  const exportableCols = mainCols.filter(col => !String(col.selector).includes('priorityCol'));
  const headers = exportableCols.map(col => col.name);

  const rows = data.map(row => {
    return exportableCols.map(col => {
      try {
        return col.selector(row);
      } catch (e) {
        return '';
      }
    });
  });

  const worksheet = XLSX.utils.aoa_to_sheet([headers, ...rows]);
  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, worksheet, 'Dados');

  const xlsxBuffer = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
  const blob = new Blob([xlsxBuffer], { type: 'application/octet-stream' });
  saveAs(blob, filename);
}
